import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { ManageCreditAccountRightSidePanelType } from 'src/types';

export interface ManageCreditPageRightSidePanelState {
  activePanelView: ManageCreditAccountRightSidePanelType | null;
}

const initialState = {
  activePanelView: null,
} as ManageCreditPageRightSidePanelState;

export const manageCreditPageRightSidePanelSlice = createSlice({
  name: 'manageCreditPageRightSidePanel',
  initialState,
  reducers: {
    setActivePanelView: (
      state,
      { payload }: PayloadAction<ManageCreditAccountRightSidePanelType | null>,
    ) => {
      state.activePanelView = payload;
    },
  },
});

export const manageCreditPageRightSidePanelState = (state: RootState) =>
  state.manageCreditPageRightSidePanel as ManageCreditPageRightSidePanelState;

export const { setActivePanelView } =
  manageCreditPageRightSidePanelSlice.actions;

export default manageCreditPageRightSidePanelSlice.reducer;
